module.exports = __webpack_public_path__ + "media/images/homepage/hero-d3d6d7d94f03bf932c195983b1e978bf.png";